import React, { createContext, useEffect, useMemo, useRef } from 'react';
import { makeAnalyticsProductListViewedEventData } from '../analytics-segment/events/product-list-viewed';
import { useAnalyticsSimplified as useAnalytics } from '@scentregroup/analytics';
import { createAnalyticsImpressionTrackerState, createProductListViewedEventInitialState } from './create-analytics-impression-tracker-state';
import { jsx as _jsx } from "react/jsx-runtime";
export const AnalyticsImpressionTrackerContext = /*#__PURE__*/createContext(null);
AnalyticsImpressionTrackerContext.displayName = 'AnalyticsImpressionTrackerContext';
export const AnalyticsImpressionTrackerProvider = _ref => {
  let {
    children
  } = _ref;
  const productListViewedState = useRef(() => createProductListViewedEventInitialState({}));
  const {
    trackEvent
  } = useAnalytics();
  const state = useMemo(() => createAnalyticsImpressionTrackerState({
    productListViewed: {
      transform: makeAnalyticsProductListViewedEventData,
      state: productListViewedState.current()
    },
    trackEvent
  }), [trackEvent]);
  useEffect(() => {
    const onUnload = () => {
      state.finalize();
    };
    window.addEventListener('beforeunload', onUnload);
    return () => {
      window.removeEventListener('beforeunload', onUnload);
    };
  }, [state]);
  return /*#__PURE__*/_jsx(AnalyticsImpressionTrackerContext.Provider, {
    value: state.context,
    children: children
  });
};
export const useAnalyticsImpressionTracker = () => {
  const context = React.useContext(AnalyticsImpressionTrackerContext);
  if (!context) {
    throw new Error('useAnalyticsImpressionTracker() must be used within an <AnalyticsImpressionTrackerProvider />');
  }
  return context;
};